const Collabs = () => {
    return ( 
        <>
         <div className="collabs">
            <h1>Collaborations</h1>  
            <div className="collab-poem">
              <div className="collab-image">
              <img src="images/talk_of_destiny.webp" alt="" className="collab-poem-image" />
              </div>
              
            <div className="collab-poem-body">
            Fuck these my feelings. <br />
            An addict to love, right from the beginning<br />
            Elevating, Intoxicating-- <br />
             I feel to the ceiling.<br />
            Reeling into my thinking <br />
             and feelings, meaning. <br />
            A change- <br />
            doubt, has creeped into what i beleive <br />
            What was it all for? <br />
            I guess I was deceived  <br/>
            for life keep reminding me that everything is ultimately uncertain...<br />
            Hurting me in the process and keeping overthinking<br />
            behind the curtains<br /> <br />
            
            Brainstorming to make a choice to shape the future <br />
            I will do-- <br />
            for certain, do <br /> <br />

            I am fucked up, <br />
            ended up on the wrong avenue. <br />
            From that feeling of belonging <br />
            to being left alone, without any sort of bearing. <br /> <br />
            
            How did I wind up here? <br />
            fragile heart; a blown up fuse, <br />
            Without current, out of the circuit. <br />
            Circumnavigating the lost ruins. <br />
            Submerged in our toxic love, <br />
            enslaved by cupid's arrow; <br />
            rose thorns at death's tomb. <br /> <br />

            My heart an enclave, <br />
            sandwiched between her and her honeymoon, <br />
            the darkest skies , my muse. <br />
            With a heavy heart and no further Ado, <br />
            I guess ut's time for farewells, a garden view-- <br />
            till the words were left hanging on my lips, <br />
            by fate's thread, <br />
            cold whispers of the wind, "Adieu" <br />
            The best of wanderings. <br/>
             serendipity, <br />
            all the way through.
            <h3>Written By TE Mass X  Adeyemi</h3>
            </div>
          </div>   
        </div>       
        </>
     );
}
 
export default Collabs;